// 校验文件：例如判断环境，校验邮箱，电话等等````

/**
 * 判断path是否为外链
 * @param {string} path
 * @returns {Boolean}
 */
export const isExternal = (path) => {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export const isWeiXin = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/MicroMessenger/i.test(ua) && !/wxwork/i.test(ua)) {
    return true
  } else {
    return false
  }
}
export const isAndroid =  () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/android/.test(ua)) {
    return true
  } else {
    return false
  }
}
export const isIOS =  () => {
  let ua = window.navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) {
    return true
  } else {
    return false
  }
}
